EmployerTypeApp.Views.Override = Backbone.View.extend({
    el: ".employer-type-container", 

    events: {
        "click #override-btn": "changeType",
        "click #recalc-btn": "recalcType",
        "click #delete-btn": "deleteEmployer"
    },

    initialize: function() {
        this.delegateEvents();
    },

    changeType: function(e) {
        e.preventDefault();
        var employerType = this.$el.find('#employer-type option:selected').text();
        var employerId = this.$el.find('#override-btn').attr('data-company');
        $.ajax({
            type: "POST",
            url: "/api/admin/manual-override",
            data: {employerType, employerId}
        }).then(function(response) {
            if(response.company) {
                toastr["success"](response.company.name+" has been assigned a new type");
            } else {
                toastr["error"](response.error);
            }
        });
    },

    recalcType: function(e) {
        e.preventDefault();
        var employerId = this.$el.find('#recalc-btn').attr('data-company');
        $.ajax({
            type: "POST",
            url: "/api/admin/recalculate",
            data: {employerId},
            success: function(response) {
                $('#employer-type option').filter(function() {
                    return $(this).text() === response.company.type; 
                }).prop('selected', true).trigger('change');
			},
        }).then(function(response) {
            toastr["success"]("Type has been recalculated for "+response.company.name);
        });
    },

    deleteEmployer: function(e) {
        e.preventDefault();
        var employerId = this.$el.find('#recalc-btn').attr('data-company');
        swal({
            type: "error",
            title: "Are you sure you want to delete this employer?",
            text: "NOTE: This action cannot be undone",
            showCancelButton: true
        }).then(function(res) {
            $.ajax({
                type: "POST",
                url: "/api/admin/delete",
                data: {employerId}
            }).then(function(response) {
                toastr["success"]("Company has been deleted successfully!");
            });
        });
    },
});